import { Box } from '@apia/theme';
import FiltersSetterController, {
  TFilterSaveDate,
} from './FiltersSettersController';
import { Checkbox, Select, Input, validationsStore } from '@apia/validations';
import { getLabel, noNaN } from '../../../../../utils/util';
import { observer } from 'mobx-react-lite';
import { TApiaFilter } from '../../../../../types';
import { getDateFormat, useDebouncedCallback } from '@apia/util';
import { useAppDispatch } from '../../../../../hooks/hooks';
import useCurrentListId from '../../../common/lists/hooks/useCurrentListId';
import { queryActions } from '../../../../../store/querySlice';
import store from '../../../../../store';
import { calculateDate } from '../FiltersSetter';
import dayjs from 'dayjs';
import queriesQueue from '../../../../../store/querySlice/queueController';
// import usePrevious from '../../../../../hooks/usePrevious';
import { ApiaUtil, FieldLabel } from '@apia/components';
import { reaction } from 'mobx';

const DateFilterSetter = observer(
  ({
    controller,
    filter,
    i,
    setFilters,
  }: {
    controller: FiltersSetterController;
    filter: TFilterSaveDate & {
      filter: TApiaFilter;
      readonly: boolean;
      required: boolean;
    };
    i: number;
    setFilters: () => Promise<void>;
  }) => {
    if (
      controller.validDateRef[(controller.filters[i] as TFilterSaveDate).id] ===
      undefined
    ) {
      controller.validDateRef[(controller.filters[i] as TFilterSaveDate).id] =
        true;
    }
    const dateFormat = window.strDateFormat.toLocaleUpperCase();
    const readonly = filter.readonly;
    const dispatch = useAppDispatch();
    const fieldId = useCurrentListId();
    // const previousValidDateRef = usePrevious(
    //   controller.validDateRef[(controller.filters[i] as TFilterSaveDate).id],
    // );

    const validateDates = () => {
      const currentFilter = controller.filters[i] as TFilterSaveDate;
      if (!currentFilter.chkFromStartOf && currentFilter.dateTo) {
        const initialDate = currentFilter.dateFrom.fixedValue;
        const finalDate = currentFilter.dateTo.fixedValue;

        const dateFormat = getDateFormat();
        const fixedInitialDate =
          initialDate !== '' ? dayjs(initialDate, dateFormat) : '';
        let fixedDateTimestamp: string = '';
        if (
          typeof fixedInitialDate !== 'string' &&
          fixedInitialDate.isValid()
        ) {
          fixedDateTimestamp = fixedInitialDate.valueOf().toString();
        }

        const fixedFinalDate =
          finalDate !== '' ? dayjs(finalDate, dateFormat) : '';
        let fixedFinalDateTimestamp: string = '';
        if (typeof fixedFinalDate !== 'string' && fixedFinalDate.isValid()) {
          fixedFinalDateTimestamp = fixedFinalDate.valueOf().toString();
        }
        if (fixedDateTimestamp && fixedFinalDateTimestamp) {
          return noNaN(fixedDateTimestamp) <= noNaN(fixedFinalDateTimestamp);
        } else {
          return true;
        }
      }
      return true;
    };
    const handleChangingFilter = useDebouncedCallback(async () => {
      const currentFilter = controller.filters[i] as TFilterSaveDate;
      if (!currentFilter.chkFromStartOf && currentFilter.dateTo) {
        const initialDate = currentFilter.dateFrom.fixedValue;
        const finalDate = currentFilter.dateTo.fixedValue;

        const dateFormat = getDateFormat();
        const fixedInitialDate =
          initialDate !== '' ? dayjs(initialDate, dateFormat) : '';
        let fixedDateTimestamp: string = '';
        if (
          typeof fixedInitialDate !== 'string' &&
          fixedInitialDate.isValid()
        ) {
          fixedDateTimestamp = fixedInitialDate.valueOf().toString();
        }

        const fixedFinalDate =
          finalDate !== '' ? dayjs(finalDate, dateFormat) : '';
        let fixedFinalDateTimestamp: string = '';
        if (typeof fixedFinalDate !== 'string' && fixedFinalDate.isValid()) {
          fixedFinalDateTimestamp = fixedFinalDate.valueOf().toString();
        }
        if (fixedDateTimestamp && fixedFinalDateTimestamp) {
          controller.validDateRef[
            (controller.filters[i] as TFilterSaveDate).id
          ] = fixedDateTimestamp <= fixedFinalDateTimestamp;
        } else {
          controller.validDateRef[
            (controller.filters[i] as TFilterSaveDate).id
          ] = true;
        }
      }
      // await queriesQueue.run(setFilters);
      const runAutomatically = filter.filter.runAutomatically === true;
      if (currentFilter.detectOnChange || runAutomatically) {
        const filters: TApiaFilter[] = [];
        if ((controller.filters[i] as TFilterSaveDate).hideToFilter) {
          filters.push({
            ...filter,
            currentValue: calculateDate({
              amountOf: (controller.filters[i] as TFilterSaveDate).dateFrom
                .amountOf,
              chkFromStartOfValue: (controller.filters[i] as TFilterSaveDate)
                .chkFromStartOf,
              fixedValue: (controller.filters[i] as TFilterSaveDate).dateFrom
                .fixedValue,
              fromStartOfValue: (controller.filters[i] as TFilterSaveDate)
                .dateFrom.fromStartOfValue,
            }),
            savedValue: JSON.stringify({
              dateFrom: (controller.filters[i] as TFilterSaveDate).dateFrom,
              chkFromStartOf: (controller.filters[i] as TFilterSaveDate)
                .chkFromStartOf,
            }),
          });
        } else {
          let dateFrom = '';
          if ((controller.filters[i] as TFilterSaveDate).chkFromStartOf) {
            dateFrom = calculateDate({
              amountOf: (controller.filters[i] as TFilterSaveDate).dateFrom
                .amountOf,
              chkFromStartOfValue: (controller.filters[i] as TFilterSaveDate)
                .chkFromStartOf,
              fromStartOfValue: (controller.filters[i] as TFilterSaveDate)
                .dateFrom.fromStartOfValue,
              fixedValue: (controller.filters[i] as TFilterSaveDate).dateFrom
                .fixedValue,
            });
          } else if (
            (controller.filters[i] as TFilterSaveDate).dateFrom.fixedValue
          ) {
            dateFrom = (controller.filters[i] as TFilterSaveDate).dateFrom
              .fixedValue;
          }
          let dateTo = '';
          if ((controller.filters[i] as TFilterSaveDate).chkFromStartOf) {
            dateTo = dayjs().startOf('day').format(dateFormat);
          } else if (
            (controller.filters[i] as TFilterSaveDate).dateTo!.fixedValue
          ) {
            dateTo = (controller.filters[i] as TFilterSaveDate).dateTo!
              .fixedValue;
          }
          filters.push({
            ...controller.filters[i].filter,
            currentValue: dateFrom,
            filterToValue: dateTo,
            savedValue: JSON.stringify({
              dateFrom: (controller.filters[i] as TFilterSaveDate).dateFrom,
              dateTo: {
                fixedValue: (controller.filters[i] as TFilterSaveDate).dateTo
                  ?.fixedValue,
              },
              chkFromStartOf: (controller.filters[i] as TFilterSaveDate)
                .chkFromStartOf,
            }),
          });
        }

        await queriesQueue.runAction(
          'directUpdateFilters',
          async () => {
            await dispatch(
              queryActions.updateFilters(
                fieldId === 'userQuery'
                  ? {
                      fieldId,
                      filters: filters,
                      forceSearch: runAutomatically,
                      fromFiltersSetters: true,
                    }
                  : {
                      fieldId,
                      filters: filters,
                      forceSearch: runAutomatically,
                      fromFiltersSetters: true,
                      query: {
                        workingMode:
                          fieldId === 'taskListQueryFreeTasks' ? 'R' : 'I',
                      },
                    },
              ),
            ).finally(() => {
              queriesQueue.runAction(
                'directUpdateFilters',
                async () => {
                  const tableFilters =
                    store.getState().querySlice.queries[fieldId].filters;

                  if (tableFilters) {
                    controller.updateFilters(
                      tableFilters.map((f) => {
                        return f.apiaFilter;
                      }),
                    );
                  }
                  setFilters();
                },
                ['fromUpdateFilters', 'fromSearchfromUpdateFilters'],
              );
            });
          },
          ['fromUpdateFilters', 'fromSearchfromUpdateFilters'],
        );
      }
    });

    reaction(
      () => controller.filters[i] as TFilterSaveDate,
      (changingFilter: TFilterSaveDate) => {
        const checkbox = validationsStore.getFieldStore(
          'FiltersSetter',
          (controller.filters[i] as TFilterSaveDate).id + '_fromStartOf',
        );
        const startOfCombo = validationsStore.getFieldStore(
          'FiltersSetter',
          (controller.filters[i] as TFilterSaveDate).id + '_startOfOptions',
        );
        const amountOfInput = validationsStore.getFieldStore(
          'FiltersSetter',
          (controller.filters[i] as TFilterSaveDate).id + '_amountOf',
        );
        const initialDate = validationsStore.getFieldStore(
          'FiltersSetter',
          (controller.filters[i] as TFilterSaveDate).id + '_fixedStart',
        );

        if ((controller.filters[i] as TFilterSaveDate).hideToFilter) {
          if (changingFilter.chkFromStartOf) {
            startOfCombo.value = changingFilter.dateFrom.fromStartOfValue;
            amountOfInput.value = changingFilter.dateFrom.amountOf;
            checkbox.value = true;
            initialDate.value = calculateDate({
              amountOf: changingFilter.dateFrom.amountOf,
              chkFromStartOfValue: true,
              fromStartOfValue: changingFilter.dateFrom.fromStartOfValue,
              fixedValue: changingFilter.dateFrom.fixedValue,
            });
          } else {
            checkbox.value = false;
            initialDate.value = changingFilter.dateFrom.fixedValue;
          }
        } else {
          const finalDate = validationsStore.getFieldStore(
            'FiltersSetter',
            (controller.filters[i] as TFilterSaveDate).id + '_fixedEnd',
          );
          if (changingFilter.chkFromStartOf) {
            startOfCombo.value = changingFilter.dateFrom.fromStartOfValue;
            amountOfInput.value = changingFilter.dateFrom.amountOf;
            initialDate.value = calculateDate({
              amountOf: changingFilter.dateFrom.amountOf,
              chkFromStartOfValue: true,
              fromStartOfValue: changingFilter.dateFrom.fromStartOfValue,
              fixedValue: changingFilter.dateFrom.fixedValue,
            });
            finalDate.value = calculateDate({
              amountOf: changingFilter.dateFrom.amountOf,
              chkFromStartOfValue: true,
              fromStartOfValue: changingFilter.dateFrom.fromStartOfValue,
              fixedValue: changingFilter.dateTo!.fixedValue,
            });
            checkbox.value = true;
          } else {
            checkbox.value = false;
            initialDate.value = changingFilter.dateFrom.fixedValue;
            finalDate.value = changingFilter.dateTo!.fixedValue;
          }
        }
      },
    );

    reaction(
      () => (controller.filters[i] as TFilterSaveDate).dateFrom.fixedValue,
      (value) => {
        const initialDate = validationsStore.getFieldStore(
          'FiltersSetter',
          (controller.filters[i] as TFilterSaveDate).id + '_fixedStart',
        );
        if (!(controller.filters[i] as TFilterSaveDate).chkFromStartOf) {
          initialDate.value = value;
        }
      },
    );
    if ((controller.filters[i] as TFilterSaveDate).hideToFilter) {
      return (
        <Box className="dateFilterValue_container">
          <Checkbox
            aria-readonly={readonly}
            name={
              (controller.filters[i] as TFilterSaveDate).id + '_fromStartOf'
            }
            className="dynamicDatesChk"
            onChange={(ev) => {
              (controller.filters[i] as TFilterSaveDate).chkFromStartOf =
                ev.target.checked;

              (controller.filters[i] as TFilterSaveDate).dateFrom.fixedValue =
                '';

              handleChangingFilter();
            }}
            label={getLabel('lblDynamicDates').text}
            initialValue={
              (controller.filters[i] as TFilterSaveDate).chkFromStartOf
                ? 'on'
                : 'off'
            }
          />

          <Box
            className="startOfOptions_container"
            sx={{
              display: (controller.filters[i] as TFilterSaveDate).chkFromStartOf
                ? 'flex'
                : 'none',
            }}
          >
            <Select
              name={
                (controller.filters[i] as TFilterSaveDate).id +
                '_startOfOptions'
              }
              aria-readonly={readonly}
              onChange={(ev) => {
                (
                  controller.filters[i] as TFilterSaveDate
                ).dateFrom.fromStartOfValue = ev.target.value;
                (controller.filters[i] as TFilterSaveDate).hasChanged = true;
                handleChangingFilter();
              }}
              options={[
                { value: 'actualDay', label: getLabel('lblCurrentDay').text },
                { value: 'actualWeek', label: getLabel('lblCurrentWeek').text },
                {
                  value: 'actualMonth',
                  label: getLabel('lblCurrentMonth').text,
                },
                {
                  value: 'actualQuarter',
                  label: getLabel('lblCurrentQuarter').text,
                },
                {
                  value: 'actualSemester',
                  label: getLabel('lblCurrentSemester').text,
                },
                { value: 'actualYear', label: getLabel('lblCurrentYear').text },
                { value: 'daysAmount', label: getLabel('lblLastXDays').text },
                { value: 'weeksAmount', label: getLabel('lblLastXWeeks').text },
                {
                  value: 'monthsAmount',
                  label: getLabel('lblLastXMonth').text,
                },
                {
                  value: 'quartersAmount',
                  label: getLabel('lblLastXQuarters').text,
                },
                {
                  value: 'semestersAmount',
                  label: getLabel('lblLastXSemesters').text,
                },
                { value: 'yearsAmount', label: getLabel('lblLastXYears').text },
              ]}
              initialValue={
                (controller.filters[i] as TFilterSaveDate).dateFrom
                  .fromStartOfValue
              }
            ></Select>
            <Box
              className="amountOfField_container"
              sx={{
                display: [
                  'daysAmount',
                  'weeksAmount',
                  'monthsAmount',
                  'quartersAmount',
                  'semestersAmount',
                  'yearsAmount',
                ].includes(
                  (controller.filters[i] as TFilterSaveDate).dateFrom
                    .fromStartOfValue,
                )
                  ? 'block'
                  : 'none',
              }}
            >
              <Input
                name={
                  (controller.filters[i] as TFilterSaveDate).id + '_amountOf'
                }
                type="number"
                readOnly={readonly}
                step={1}
                min={0}
                value={
                  (controller.filters[i] as TFilterSaveDate).dateFrom.amountOf
                }
                initialValue={String(
                  (controller.filters[i] as TFilterSaveDate).dateFrom.amountOf,
                )}
                onChange={(ev) => {
                  (controller.filters[i] as TFilterSaveDate).dateFrom.amountOf =
                    noNaN(ev.target.value, 0);
                  (controller.filters[i] as TFilterSaveDate).hasChanged = true;
                  handleChangingFilter();
                }}
              />
            </Box>
          </Box>
          <Box
            className="fixedOptions_container"
            sx={{
              display: (controller.filters[i] as TFilterSaveDate).chkFromStartOf
                ? 'none'
                : 'flex',
            }}
          >
            <Input
              name={
                (controller.filters[i] as TFilterSaveDate).id + '_fixedStart'
              }
              type="date"
              readOnly={readonly}
              validationRules={{
                required:
                  controller.filters[i].required ||
                  (controller.filters[i] as TFilterSaveDate).dateFromRequired,
              }}
              initialValue={
                (controller.filters[i] as TFilterSaveDate).dateFrom.fixedValue
              }
              onChange={(ev) => {
                if (
                  (controller.filters[i] as TFilterSaveDate).dateFrom
                    .fixedValue !== ev.target.value
                ) {
                  (
                    controller.filters[i] as TFilterSaveDate
                  ).dateFrom.fixedValue = ev.target.value;
                  (controller.filters[i] as TFilterSaveDate).hasChanged = true;
                  handleChangingFilter();
                }
              }}
            />
          </Box>
        </Box>
      );
    }
    reaction(
      () => (controller.filters[i] as TFilterSaveDate).dateTo!.fixedValue,
      (value) => {
        const finalDate = validationsStore.getFieldStore(
          'FiltersSetter',
          (controller.filters[i] as TFilterSaveDate).id + '_fixedEnd',
        );
        if (!(controller.filters[i] as TFilterSaveDate).chkFromStartOf) {
          finalDate.value = value;
        }
      },
    );

    // if (
    //   !controller.validDateRef[(controller.filters[i] as TFilterSaveDate).id] &&
    //   previousValidDateRef.current
    // ) {
    //   ApiaUtil.instance.notifications.notify({
    //     message: window.MSG_FEC_FIN_MAY_FEC_INI,
    //   });
    // }
    return (
      <Box className="dateFilterValue_container">
        <Checkbox
          name={(controller.filters[i] as TFilterSaveDate).id + '_fromStartOf'}
          aria-readonly={readonly}
          className="dynamicDatesChk"
          value={
            (controller.filters[i] as TFilterSaveDate).chkFromStartOf
              ? 'on'
              : 'off'
          }
          initialValue={
            (controller.filters[i] as TFilterSaveDate).chkFromStartOf
              ? 'on'
              : 'off'
          }
          onChange={(ev) => {
            (controller.filters[i] as TFilterSaveDate).dateFrom.amountOf = 0;
            (
              controller.filters[i] as TFilterSaveDate
            ).dateFrom.fromStartOfValue = 'actualDay';
            (controller.filters[i] as TFilterSaveDate).dateFrom.fixedValue = '';
            (controller.filters[i] as TFilterSaveDate).dateTo!.fixedValue = '';
            (controller.filters[i] as TFilterSaveDate).chkFromStartOf =
              ev.target.checked;
            handleChangingFilter();
          }}
          label={getLabel('lblDynamicDates').text}
          sx={{ width: 'fit-content' }}
        />
        <Box
          className="startOfOptions_container"
          sx={{
            display: (controller.filters[i] as TFilterSaveDate).chkFromStartOf
              ? 'flex'
              : 'none',
          }}
        >
          <Select
            name={
              (controller.filters[i] as TFilterSaveDate).id + '_startOfOptions'
            }
            aria-readonly={readonly}
            value={
              (controller.filters[i] as TFilterSaveDate).dateFrom
                .fromStartOfValue
            }
            initialValue={
              (controller.filters[i] as TFilterSaveDate).dateFrom
                .fromStartOfValue
            }
            onChange={(ev) => {
              (
                controller.filters[i] as TFilterSaveDate
              ).dateFrom.fromStartOfValue = ev.target.value;
              (controller.filters[i] as TFilterSaveDate).hasChanged = true;
              handleChangingFilter();
            }}
            options={[
              { value: 'actualDay', label: getLabel('lblCurrentDay').text },
              { value: 'actualWeek', label: getLabel('lblCurrentWeek').text },
              {
                value: 'actualMonth',
                label: getLabel('lblCurrentMonth').text,
              },
              {
                value: 'actualQuarter',
                label: getLabel('lblCurrentQuarter').text,
              },
              {
                value: 'actualSemester',
                label: getLabel('lblCurrentSemester').text,
              },
              { value: 'actualYear', label: getLabel('lblCurrentYear').text },
              { value: 'daysAmount', label: getLabel('lblLastXDays').text },
              { value: 'weeksAmount', label: getLabel('lblLastXWeeks').text },
              {
                value: 'monthsAmount',
                label: getLabel('lblLastXMonth').text,
              },
              {
                value: 'quartersAmount',
                label: getLabel('lblLastXQuarters').text,
              },
              {
                value: 'semestersAmount',
                label: getLabel('lblLastXSemesters').text,
              },
              { value: 'yearsAmount', label: getLabel('lblLastXYears').text },
            ]}
          ></Select>
          <Box
            className="amountOfField_container"
            sx={{
              display: [
                'daysAmount',
                'weeksAmount',
                'monthsAmount',
                'quartersAmount',
                'semestersAmount',
                'yearsAmount',
              ].includes(
                (controller.filters[i] as TFilterSaveDate).dateFrom
                  .fromStartOfValue,
              )
                ? 'block'
                : 'none',
            }}
          >
            <Input
              name={(controller.filters[i] as TFilterSaveDate).id + '_amountOf'}
              readOnly={readonly}
              validationRules={{
                required:
                  controller.filters[i].required &&
                  [
                    'daysAmount',
                    'weeksAmount',
                    'monthsAmount',
                    'quartersAmount',
                    'semestersAmount',
                    'yearsAmount',
                  ].includes(
                    (controller.filters[i] as TFilterSaveDate).dateFrom
                      .fromStartOfValue,
                  ),
              }}
              type="number"
              value={
                (controller.filters[i] as TFilterSaveDate).dateFrom.amountOf
              }
              initialValue={String(
                (controller.filters[i] as TFilterSaveDate).dateFrom.amountOf,
              )}
              onChange={(ev) => {
                (controller.filters[i] as TFilterSaveDate).dateFrom.amountOf =
                  noNaN(ev.target.value, 0);
                (controller.filters[i] as TFilterSaveDate).hasChanged = true;
                handleChangingFilter();
              }}
            />
          </Box>
        </Box>
        <Box
          className="fixedOptions_container"
          sx={{
            display: (controller.filters[i] as TFilterSaveDate).chkFromStartOf
              ? 'none'
              : 'flex',
          }}
        >
          <FieldLabel
            label={getLabel('lblProEleFrom').text}
            required={
              filter.filter.dateFromRequired ||
              (filter.filter.required &&
                !filter.filter.dateToRequired &&
                !filter.filter.dateFromRequired)
            }
            requiredMarkPosition={
              window.SHOW_REQUIRED_POSITION === '1' ? 'before' : 'after'
            }
          >
            <Input
              name={
                (controller.filters[i] as TFilterSaveDate).id + '_fixedStart'
              }
              readOnly={readonly}
              validationRules={{
                required:
                  controller.filters[i].required ||
                  (controller.filters[i] as TFilterSaveDate).dateFromRequired,
              }}
              type="date"
              className={
                controller.validDateRef[
                  (controller.filters[i] as TFilterSaveDate).id
                ]
                  ? ''
                  : 'requiredFilter__Border'
              }
              value={
                (controller.filters[i] as TFilterSaveDate).dateFrom.fixedValue
              }
              initialValue={
                (controller.filters[i] as TFilterSaveDate).dateFrom.fixedValue
              }
              onChange={(ev) => {
                if (
                  (controller.filters[i] as TFilterSaveDate).dateFrom
                    .fixedValue !== String(ev)
                ) {
                  (
                    controller.filters[i] as TFilterSaveDate
                  ).dateFrom.fixedValue = String(ev);
                  (controller.filters[i] as TFilterSaveDate).hasChanged = true;
                  if (!validateDates()) {
                    controller.validDateRef[
                      (controller.filters[i] as TFilterSaveDate).id
                    ] = false;
                    ApiaUtil.instance.notifications.notify({
                      message: window.MSG_FEC_FIN_MAY_FEC_INI,
                    });
                  } else {
                    handleChangingFilter();
                  }
                }
              }}
              onBlur={() => {
                if (
                  !controller.validDateRef[
                    (controller.filters[i] as TFilterSaveDate).id
                  ]
                ) {
                  (
                    controller.filters[i] as TFilterSaveDate
                  ).dateFrom.fixedValue = '';
                  controller.validDateRef[
                    (controller.filters[i] as TFilterSaveDate).id
                  ] = true;
                }
              }}
            />
          </FieldLabel>

          <FieldLabel
            label={getLabel('lblProEleTo').text}
            required={
              filter.filter.dateToRequired ||
              (filter.filter.required &&
                !filter.filter.dateToRequired &&
                !filter.filter.dateFromRequired)
            }
            requiredMarkPosition={
              window.SHOW_REQUIRED_POSITION === '1' ? 'before' : 'after'
            }
          >
            <Input
              name={(controller.filters[i] as TFilterSaveDate).id + '_fixedEnd'}
              readOnly={readonly}
              validationRules={{
                required:
                  controller.filters[i].required ||
                  (controller.filters[i] as TFilterSaveDate).dateToRequired,
              }}
              type="date"
              className={
                controller.validDateRef[
                  (controller.filters[i] as TFilterSaveDate).id
                ]
                  ? ''
                  : 'requiredFilter__Border'
              }
              value={
                (controller.filters[i] as TFilterSaveDate).dateTo!.fixedValue
              }
              initialValue={
                (controller.filters[i] as TFilterSaveDate).dateTo!.fixedValue
              }
              onChange={(ev) => {
                if (
                  (controller.filters[i] as TFilterSaveDate).dateTo!
                    .fixedValue !== String(ev)
                ) {
                  (
                    controller.filters[i] as TFilterSaveDate
                  ).dateTo!.fixedValue = String(ev);
                  (controller.filters[i] as TFilterSaveDate).hasChanged = true;
                  if (!validateDates()) {
                    controller.validDateRef[
                      (controller.filters[i] as TFilterSaveDate).id
                    ] = false;
                    ApiaUtil.instance.notifications.notify({
                      message: window.MSG_FEC_FIN_MAY_FEC_INI,
                    });
                  } else {
                    handleChangingFilter();
                  }
                }
              }}
              onBlur={() => {
                if (
                  !controller.validDateRef[
                    (controller.filters[i] as TFilterSaveDate).id
                  ]
                ) {
                  (
                    controller.filters[i] as TFilterSaveDate
                  ).dateTo!.fixedValue = '';
                  controller.validDateRef[
                    (controller.filters[i] as TFilterSaveDate).id
                  ] = true;
                }
              }}
            />
          </FieldLabel>
        </Box>
      </Box>
    );
  },
);

export default DateFilterSetter;
